module.exports = __webpack_public_path__ + "img/slider_desktop.332adcb3.gif";